"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _min = _interopRequireDefault(require("lodash/min"));

var _victory = require("victory");

var _reactFela = require("react-fela");

var _util = require("../../../util");

var _ = require("../..");

var css = _interopRequireWildcard(require("./BarChart.style."));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Legend = ({
  legend
}) => {
  if (!legend) {
    return null;
  }

  return (0, _pragma.createFelaElement)(_.View, null, legend.map(item => (0, _pragma.createFelaElement)(_.View, {
    key: item.name,
    css: css.legendItem,
    alignItems: "center",
    justifyContent: "center"
  }, (0, _pragma.createFelaElement)(_.View, {
    css: css.legendSymbol,
    cssProps: {
      color: item.color
    }
  }), (0, _pragma.createFelaElement)(_.Text, {
    size: "xs"
  }, item.name))));
};
/**
 * BarChart is a chart or graph that presents categorical data with rectangular bars with heights or lengths proportional to the values that they represent. The bars can be plotted vertically or horizontally. A vertical bar chart is sometimes called a column chart.
 *
 * In grouped (clustered) bar charts, for each categorical group there are two or more bars color-coded to represent a particular grouping.
 * For example, a business owner with two stores might make a grouped bar chart with different colored bars to represent each store: the horizontal axis would show the months of the year and the vertical axis would show revenue.
 */


const BarChart = /*#__PURE__*/React.forwardRef(({
  data,
  legend,
  horizontal,
  barProps,
  grouped = false,
  offset,
  tickFormat,
  barWidth = 24,
  animation,
  tickValues,
  axisValue,
  containerProps,
  groupProps,
  axisProps,
  dependAxisProps,
  colorScale,
  cursorType,
  barLabelFormat = 'numerical',
  chartColor,
  ...otherProps
}, ref) => {
  const fela = (0, _reactFela.useFela)();
  const theme = fela.theme;
  const barChartTheme = theme.barChart.primary;
  const tickLabelsFill = (0, _util.color)(theme, barChartTheme.tickLabelsFill);
  const strokeColor = (0, _util.color)(theme, barChartTheme.strokeColor);
  const gridStroveOdd = (0, _util.color)(theme, barChartTheme.gridStroveOdd);
  const labelsFill = (0, _util.color)(theme, barChartTheme.labelsFill);
  const chartColorPrimary = (0, _util.color)(theme, barChartTheme.chartColorPrimary);
  const chartColorSecondary = (0, _util.color)(theme, barChartTheme.chartColorSecondary);

  const setBarLabel = labelData => {
    if (barLabelFormat === 'percentage') {
      return labelData.map(({
        y
      }) => "".concat(y, " %"));
    }

    return labelData.map(({
      y
    }) => "".concat(y === null || y === void 0 ? void 0 : y.toLocaleString('hi')));
  };

  const setTickFormat = tick => {
    if (!horizontal) return tick;
    return String(tick).split(' ').join('\n');
  };

  const setAxisValue = () => {
    let minValue = 0;
    if (axisValue) return axisValue;
    if (tickValues) minValue = Number((0, _min.default)(tickValues));
    return minValue > 0 ? 0 : minValue;
  };

  return (0, _pragma.createFelaElement)(_.View, _extends({
    ref: ref,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  }, containerProps), (0, _pragma.createFelaElement)(_victory.VictoryChart, _extends({}, otherProps, {
    theme: barChartTheme
  }), (0, _pragma.createFelaElement)(_victory.VictoryAxis, _extends({
    style: {
      axis: {
        stroke: strokeColor
      },
      tickLabels: {
        fill: tickLabelsFill
      }
    },
    tickFormat: tickFormat || (tick => setTickFormat(tick)),
    tickLabelComponent: (0, _pragma.createFelaElement)(_victory.VictoryLabel, {
      lineHeight: 1.6
    }),
    axisValue: setAxisValue()
  }, axisProps)), (0, _pragma.createFelaElement)(_victory.VictoryAxis, _extends({
    orientation: !horizontal ? 'right' : 'top',
    dependentAxis: true,
    tickValues: tickValues,
    style: {
      tickLabels: {
        fontSize: '10px',
        fill: tickLabelsFill
      },
      axis: {
        stroke: 'transparent'
      },
      grid: {
        stroke: ({
          index
        }) => {
          if (+index % 2 === 0) return strokeColor;
          return gridStroveOdd;
        }
      }
    }
  }, dependAxisProps)), grouped ? (0, _pragma.createFelaElement)(_victory.VictoryGroup, _extends({
    horizontal: horizontal,
    offset: offset || barWidth + 8,
    style: {
      data: {
        width: barWidth
      },
      labels: {
        fill: labelsFill
      }
    }
  }, groupProps), data === null || data === void 0 ? void 0 : data.map(value => {
    var _value$, _value$2;

    return (0, _pragma.createFelaElement)(_victory.VictoryBar, _extends({
      key: "".concat((_value$ = value[0]) === null || _value$ === void 0 ? void 0 : _value$.x, "-").concat((_value$2 = value[0]) === null || _value$2 === void 0 ? void 0 : _value$2.y),
      labels: setBarLabel(value),
      labelComponent: (0, _pragma.createFelaElement)(_victory.VictoryLabel, null),
      style: {
        labels: {
          fill: labelsFill
        },
        data: {
          width: barWidth,
          cursor: cursorType
        }
      },
      cornerRadius: {
        top: 4
      },
      data: value,
      animate: {
        easing: animation
      },
      colorScale: colorScale || [chartColorSecondary, chartColorPrimary]
    }, barProps));
  })) : (0, _pragma.createFelaElement)(_victory.VictoryBar, _extends({
    labels: setBarLabel(data),
    labelComponent: (0, _pragma.createFelaElement)(_victory.VictoryLabel, null),
    style: {
      data: {
        width: barWidth,
        fill: chartColor || chartColorPrimary,
        cursor: cursorType
      },
      labels: {
        fill: labelsFill
      }
    },
    cornerRadius: {
      top: 4
    },
    horizontal: horizontal,
    data: data,
    animate: {
      easing: animation
    }
  }, barProps))), (0, _pragma.createFelaElement)(Legend, {
    legend: legend
  }));
});
BarChart.displayName = 'BarChart';
var _default = BarChart;
exports.default = _default;
//# sourceMappingURL=BarChart.js.map